var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery, useLazyQuery, useMutation, NetworkStatus, } from "@apollo/client";
import { GRAPHQL_AUTH_URL, GRAPHQL_UNAUTH_URL } from "./constants";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEnhancedQuery(query, options, extraOptions) {
    if (options === void 0) { options = {}; }
    if (extraOptions === void 0) { extraOptions = { auth: true }; }
    var result = useQuery(query, __assign(__assign({}, options), { context: __assign({ uri: extraOptions.auth ? GRAPHQL_AUTH_URL : GRAPHQL_UNAUTH_URL }, options.context) }));
    return __assign(__assign({}, result), { initialLoading: result.networkStatus === NetworkStatus.loading, refetching: result.networkStatus === NetworkStatus.refetch, fetchingMore: result.networkStatus === NetworkStatus.fetchMore });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEnhancedLazyQuery(query, options, extraOptions) {
    if (options === void 0) { options = {}; }
    if (extraOptions === void 0) { extraOptions = { auth: true }; }
    return useLazyQuery(query, __assign(__assign({}, options), { context: __assign({ uri: extraOptions.auth ? GRAPHQL_AUTH_URL : GRAPHQL_UNAUTH_URL }, options.context) }));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useEnhancedMutation(mutation, options, extraOptions) {
    if (options === void 0) { options = {}; }
    if (extraOptions === void 0) { extraOptions = { auth: true }; }
    return useMutation(mutation, __assign(__assign({}, options), { context: __assign({ uri: extraOptions.auth ? GRAPHQL_AUTH_URL : GRAPHQL_UNAUTH_URL }, options.context) }));
}
